import React from 'react';
import { TextFormattedNumber } from 'components';
import { Typography } from '@material-ui/core';


interface IQuoteListingsSummaryItem {
  label: string,
  hint?: string,
  value: number,
  prefix?: string
}

const EditQuoteListingsSummaryItem = ({ label, hint = '', value, prefix = '$' }: IQuoteListingsSummaryItem) => {
  return (
    <div className="mb-2">
      <div className="flex items-center justify-between">
        <div className="font-semibold">{label}</div>
        <div className="text-right">
          <TextFormattedNumber
            value={value}
            prefix={prefix}
          />
        </div>
      </div>
      {hint && <Typography className="text-14 text-light-gray font-medium mr-2">{hint}</Typography>}
    </div>
  );
};

export default EditQuoteListingsSummaryItem;
